import { useState } from "react"

import { GameplanBlock } from "./GameplanBlock"
import WhenWhereCard from "./WhenWhereCard"

// CANONICAL-DETAIL (2026-07-04, QJ FINAL RULING -- supersedes the 2026-07-04 "side-by-side
// geometry stays" follow-up recorded below): the canonical TeeUp-detail layouts are ONLY the
// mobile Figma prototype and the PRE-ALESSANDRA web structure; Ale's restyle (incl. her
// side-by-side two-column `.gp2-row` Game Plan header, kept by the note below) is not a design
// target. Reverted to ONE outer "Game plan" card with WHEN then WHERE STACKED vertically, thin
// divider between -- while KEEPING every bug fix layered on top since `f77ff84a` (no in-column
// content duplication, full-width expand panel below whichever row is open, independent
// per-row expand state, calendar-conflict/pill-strip/popup-click-through logic in
// WhenWhereCard.tsx, all untouched). Only the container's grid/divider classes changed here
// (`md:grid-cols-2 md:divide-x` -> a single-column stack with a horizontal divider) plus the
// per-row full-width expand panel now sits directly under ITS OWN row instead of both panels
// living below a shared two-column header row.
//
// TEEUP-LIFECYCLE fix (2026-07-04, QJ ruling, screenshot-verified problem, CORRECTED per QJ
// follow-up -- side-by-side geometry stays, stacking causes navigation challenges): kept Ale's
// two-column `.gp2-row` header layout (When | Where side by side, dashed vertical divider) but
// fixed the actual bugs, which were never the side-by-side geometry itself:
//   1. DUPLICATION -- expanding used to mount GameplanBlock (GameplanHeader + DecidedSuggestion)
//      INSIDE each half-column, re-rendering the label/decided-value/address the collapsed
//      WhenWhereCard row already shows (the "Where address renders twice" bug). Fixed in
//      GameplanBlock.js: it renders ONLY the suggestion rows now, never the header/value.
//   2. HEIGHT SQUEEZE -- the duplicated sub-panel was ALSO squeezed into a half-width column,
//      which is what produced "sub-panels are squeezed, heights diverge" for lists with
//      attribution + conflict labels + popup rows. Fixed by surfacing each row's expand toggle
//      as a FULL-WIDTH panel -- never squeezed into a half column -- instead of nested inside
//      its originating column. Independent per-row expand state (expandedWhen/expandedWhere)
//      replaces the old single shared bottom toggle that opened both columns' content at once.
//      Both of these fixes are geometry-independent and are preserved unchanged in the stacked
//      layout below.
const GameplanSection = () => {
  const [expandedWhen, setExpandedWhen] = useState(false)
  const [expandedWhere, setExpandedWhere] = useState(false)

  return (
    <div data-testid="teeup-detail-gameplan-section">
      {/* Ale `.section-h` (flex justify-between, margin: 0 2px 10px) + `.section-h .lab`
          (11px, letter-spacing .14em, uppercase, color var(--muted-solid) #9AA2B1) label
          typography kept -- the canonical-layout ruling is about card/row GEOMETRY (People
          card + stacked Game plan card), not about discarding every ported visual token. */}
      <div className="mx-0.5 mb-2.5 flex items-center justify-between">
        <span className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[#9AA2B1]">
          Game plan
        </span>
      </div>

      {/* ONE outer card (canonical: People card + ONE Game plan card), overflow-hidden so
          rounded corners still clip whichever child (a row or an expanded panel) is last. */}
      <div className="overflow-hidden rounded-[13px] border border-[#E6EBF3] bg-white shadow-[0_1px_2px_rgba(0,0,0,0.03)]">
        {/* STACKED (canonical, QJ FINAL RULING): WHEN above WHERE, single column, thin solid
            divider between the two rows -- replaces the prior `md:grid-cols-2 md:divide-x
            md:divide-y-0` side-by-side geometry. Each row's own full-width expand panel now
            renders directly beneath THAT row (not both panels grouped below a shared header
            row), so the stack reads top-to-bottom: WHEN row -> [WHEN expand panel] -> divider
            -> WHERE row -> [WHERE expand panel]. */}
        <div className="flex flex-col divide-y divide-[#E6EBF3]">
          <WhenWhereCard
            type="WHEN"
            isExpanded={expandedWhen}
            setExpanded={setExpandedWhen}
          />

          {expandedWhen && (
            <div className="border-t border-dashed border-[#DCE3ED] px-[18px] py-4">
              <GameplanBlock type="WHEN" />
            </div>
          )}

          <WhenWhereCard
            type="WHERE"
            isExpanded={expandedWhere}
            setExpanded={setExpandedWhere}
          />

          {expandedWhere && (
            <div className="border-t border-dashed border-[#DCE3ED] px-[18px] py-4">
              <GameplanBlock type="WHERE" />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default GameplanSection
